import React, { useEffect } from 'react';

import { useSetRecoilState, useRecoilValue, RecoilState } from 'recoil';
import { Text, FormControl, FormLabel } from '@tq/ui-components';

import { usePermissions } from 'api';
import { ManageTeamFilterPermissionSelect } from 'components';

interface PermissionsTableCellProps {
  rowValue: string;
  editingState: RecoilState<number | undefined>;
  permissionState: RecoilState<number>;
  rowIndex: number;
  label: string;
}

export const PermissionsTableCell: React.FC<PermissionsTableCellProps> = ({
  rowValue,
  editingState,
  permissionState,
  rowIndex,
  label,
}) => {
  const currentEditRowIndex = useRecoilValue(editingState);
  const setPermissionsSate = useSetRecoilState(permissionState);
  const { data: permissionData } = usePermissions();

  useEffect(() => {
    if (currentEditRowIndex === rowIndex) {
      const defaultValue = permissionData?.permissions.find(
        (permission) => permission.label === rowValue
      );
      if (defaultValue) setPermissionsSate(defaultValue.value);
    }
  }, [rowValue, permissionData, setPermissionsSate, currentEditRowIndex, rowIndex]);

  return currentEditRowIndex === rowIndex ? (
    <FormControl width='100%'>
      <FormLabel htmlFor='input-permission'>{label}:</FormLabel>
      <ManageTeamFilterPermissionSelect
        permissionState={permissionState}
        inputId='input-permission'
      />
    </FormControl>
  ) : (
    <Text>{rowValue}</Text>
  );
};
